import { useEffect, useState } from "react";
import { selector } from "../../api";
import { TableShared } from "../../shared";
import { char, number } from "../../utils";
import { Button, Dropdown, Space, Tag } from "antd";
import { MoreOutlined, EyeOutlined } from "@ant-design/icons";
import { Message, useToaster } from "rsuite";
import { gatewayCRUD } from "../../actions/gateway";
import { DiscountDetails } from "./data";

export const DiscountContent = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortType, setSortType] = useState("");
  const [dataId, setDataId] = useState(null);
  const toaster = useToaster();

  const user = selector.User();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      gatewayCRUD
        .loadInvoiceDiscount(postsPerPage, nextPage, value, "-id")
        .then((resp) => {
          setData(resp.data.results);
          setCount(resp.data.count);
        })
        .catch((error) => {
          toaster.push(
            <Message showIcon type={"error"} header={"Error"} closable>
              <p className="h6">
                <p className="fw-bold fs-14">Oooh Sorry...!</p>
                <p className="text-dark fs-12">
                  Something went wrong, Check your network connection.
                </p>
              </p>
            </Message>,
            { placement: "topEnd", duration: 7000 },
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500);
  }, [page, postsPerPage, value, index, nextPage]);

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 50,
    },
    {
      key: "control_number",
      title: "Control Number",
      dataIndex: "control_number",
      sortable: true,
      width: 150,
    },
    {
      key: "percentage",
      title: "Percentage",
      dataIndex: "percentage",
      sortable: true,
      width: 150,
    },
    {
      key: "amount",
      title: "Amount",
      dataIndex: "amount",
      sortable: true,
      align: "right",
      width: 150,
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      align: "center",
      width: 80,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      align: "center",
      width: 50,
      render: (record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: "View",
                key: "view",
                icon: <EyeOutlined />,
              },
            ],
            onClick: (event) => {
              switch (event.key) {
                case "view":
                  setDataId(record.id);
                  setOpen(true);
                  break;
                default:
              }
            },
          }}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"small"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    sn: i + 1,
    control_number: dt.logs ? dt.logs?.control_number : "N/A",
    percentage: dt.percentage ? number.fPercent(dt.percentage) : "N/A",
    amount: dt.amount
      ? number.fNumberDoublePoint(dt.amount)
      : number.fNumberDoublePoint(0.0),
    status: (
      <Tag color={dt.is_approved ? "green" : "orange"}>
        {dt.is_approved ? "Approved" : "Pending"}
      </Tag>
    ),
  }));

  return (
    <>
      <div className="container-fluid">
        <div className="row mb-2" style={{ marginTop: -30 }}>
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-dark">Invoice Discount</p>
          </div>
          <hr />
        </div>
        <TableShared
          setOpen={setOpen}
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={count}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={value}
          setValue={setValue}
          defaultColumns={defaultColumns}
          button={null}
          link={"#"}
          showButton={true}
          sortColumn={sortColumn}
          setSortColumn={setSortColumn}
          sortType={sortType}
          setSortType={setSortType}
          setLoading={setLoading}
        />
      </div>
      <DiscountDetails
        open={open}
        setOpen={setOpen}
        index={index}
        setIndex={setIndex}
        dataId={dataId}
      />
    </>
  );
};
